import { createAction } from '@reduxjs/toolkit';

export const layersButtonClicked = createAction<
  {
    log: {
      id: number;
      name: string;
    };
  },
  'gen/layer/layersButtonClicked'
>('gen/layer/layersButtonClicked');

export const downloadClicked = createAction<
  {
    log: {
      id: number;
      name: string;
      layerName: string;
      fileName: string;
      isGroup: boolean;
      isFullSize: boolean;
      url: string;
    };
  },
  'gen/layer/downloadClicked'
>('gen/layer/downloadClicked');
